/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { CartLine } from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';

/** The menu a line was ordered from. */
const LINE_MENU_ID = 'ITSMenuId';

/** The id of the menu the line was ordered from, or undefined where the line carries none. */
export const readLineMenuId = (line: CartLine | undefined): string | undefined =>
    line?.ExtensionProperties?.find(property => property.Key === LINE_MENU_ID)?.Value?.StringValue || undefined;

/** Whether the line's menu is among the active menus, or undefined where the line or the menus do not say. */
export const isLineMenuOnOffer = (line: CartLine | undefined, activeMenuIds: string[] | undefined): boolean | undefined => {
    const menuId = readLineMenuId(line);
    return menuId && activeMenuIds && activeMenuIds.length > 0 ? activeMenuIds.includes(menuId) : undefined;
};
